import type { ReactElement } from 'react';

/**
 * Verbindungsstatus der Teilnehmeransicht (§19.2, §22.2).
 *
 * §22.2 verlangt einen sichtbaren Verbindungshinweis. Die Aussage stützt sich auf **zwei**
 * Quellen: den Echtzeitkanal und die regelmäßige Zustandsabfrage. Sie fallen nicht zusammen — ein
 * blockierter WebSocket ist nach §38 ausdrücklich vorgesehen und kein Fehler, solange die Abfrage
 * durchkommt. Genau diese Unterscheidung trägt der Text.
 *
 * Die Information ist **nicht** rein farbbasiert (§21): jeder Zustand trägt seinen Text.
 */
export function Verbindungsstatus({
  abfrageErfolgreich,
  echtzeitVerbunden,
  laeuft,
}: {
  /** Ob die letzte Zustandsabfrage geglückt ist. */
  abfrageErfolgreich: boolean;
  /** Ob der Echtzeitkanal steht. */
  echtzeitVerbunden: boolean;
  laeuft: boolean;
}): ReactElement {
  if (!abfrageErfolgreich) {
    return (
      <p
        role="status"
        className="border-warnung/40 bg-flaeche-gedaempft rounded-md border px-3 py-2 text-sm"
      >
        Keine Verbindung zum Server. Die Anzeige ist möglicherweise nicht aktuell. Es wird weiter
        versucht, die Verbindung herzustellen.
      </p>
    );
  }

  if (!echtzeitVerbunden) {
    // Der Rückfall nach §22.2 und §38: Die Anwendung bleibt vollständig nutzbar, die Anzeige
    // aktualisiert sich nur etwas später. Das ist ein Hinweis, keine Warnung.
    return (
      <p role="status" className="text-text-gedaempft text-xs">
        Verbunden. Die Anzeige wird regelmäßig aktualisiert.
      </p>
    );
  }

  return (
    <p role="status" className="text-text-gedaempft text-xs">
      {laeuft ? 'Wird aktualisiert …' : 'Verbunden. Die Anzeige aktualisiert sich sofort.'}
    </p>
  );
}
